import { useDispatch, useSelector } from "react-redux";
import { saveAs } from "file-saver";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { SystemProductsFilters } from "../SystemProductsFilters";
import { AppDispatch, RootState } from "../../../app/store";
import { FC, useCallback, useEffect } from "react";
import { actions, fetchStock } from "../slice";
import { SystemProductsList } from "../SystemProductsList";
import { exportToCSV } from "../api";
import styles from "./SystemProducts.module.css";

interface Props {
  siteId: number;
}

export const SystemProducts: FC<Props> = ({ siteId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();

  const { searchFilter, list, status } = useSelector((state: RootState) => {
    return state.system;
  });

  useEffect(() => {
    dispatch(
      actions.setFilters({
        searchFilter: searchParams.get("searchString") || "",
      })
    );
  }, [searchParams, dispatch]);

  const getStock = useCallback(() => {
    dispatch(fetchStock({ siteId, searchFilter }));
  }, [siteId, dispatch, searchFilter]);

  useEffect(() => {
    getStock();
  }, [getStock]);

  const handleExportProducts = useCallback(async () => {
    const csv = await exportToCSV(siteId);
    const name = `tenant_stock_${format(new Date(), "dd-mm-yyyy_HH:MM")}`;
    const blob = new Blob([csv.data], { type: "text/csv;charset=utf-8" });
    saveAs(blob, name);
  }, [siteId]);

  return (
    <div className={styles.container}>
      <SystemProductsFilters searchString={searchFilter} />
      <SystemProductsList
        status={status}
        stockProducts={list}
        onExport={handleExportProducts}
      />
    </div>
  );
};
